import { clsx } from 'clsx'

export default function Container({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={clsx('max-w-3xl mx-auto px-5', className)}>{children}</div>
}
